export const HIGHER_QUALIFICATION_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    name: "",
    value: "",
    priority: 0,
  },

  HIGHER_QUALIFICATION_FIELDS_CONFIG: [
    {
      fieldName: "name",
      label: "Name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Name",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "value",
      label: "Value",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Value",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "priority",
      label: "Priority",
      value: 0,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: false,
      defaultValue: 0,
    },
  ],

  // Tree configuration for flat list (no parent-child structure)
  TREE_CONFIG: {
    treeTitle: "Higher Qualifications",
    treeIcon: "🎓",
    emptyMessage: "No higher qualifications yet. Add your first one below.",
    itemDisplayFields: {
      primary: "name",
      secondary: "value",
      statusField: null, // No status field
      statusInactiveLabel: "",
      childrenField: null, // No children
    },
    fieldMappings: {
      id: "id",
      parentId: null, // No parent
      orderIndex: "priority",
      title: "name",
    },
    parentFieldName: null, // No parent field
    formLabels: {
      addNew: "➕ Add New Higher Qualification",
      edit: "✏️ Edit Higher Qualification",
      saveButton: "Add Higher Qualification",
      updateButton: "Update Higher Qualification",
      newButton: "New",
      cancelButton: "Cancel",
    },
    deleteConfirmation: (item: any) => `Delete "${item.name}"?`,
    requiresParentComponent: false, // No parent component needed
    hasParentChildStructure: false, // No tree structure
  },

  SUCCESS_MESSAGE: "Higher qualification saved successfully",
  ERROR_MESSAGE: "Failed to save higher qualification",
  SAVE_BUTTON_TEXT: "Save Higher Qualification",
  SAVING_BUTTON_TEXT: "Saving...",
  VALIDATION_ERROR_TITLE: "Validation Error",
  VALIDATION_ERROR_DESCRIPTION: "Please fill in all required fields",
  CONFIG_NOT_FOUND_ERROR: "Higher qualification configuration not found",
  UPDATE_METHOD_NOT_CONFIGURED_ERROR: "Update method not configured for higher qualification",
  HIGHER_QUALIFICATION_ID_REQUIRED_ERROR: "Higher qualification ID is required for update",
};

